module.exports = __webpack_public_path__ + "static/fonts/OpenSans-Light.df24242.woff";


//////////////////
// WEBPACK FOOTER
// ./static/font/OpenSans-Light.woff
// module id = GSkw
// module chunks = 3